import { render } from "./MobileBottomBar.vue?vue&type=template&id=36563630&scoped=true&ts=true"
import script from "./MobileBottomBar.vue?vue&type=script&lang=ts"
export * from "./MobileBottomBar.vue?vue&type=script&lang=ts"

import "./MobileBottomBar.vue?vue&type=style&index=0&id=36563630&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36563630"]])

export default __exports__